// extracted by mini-css-extract-plugin
export default {"root":"SimpleOptionCard_root__PQFlm","active":"SimpleOptionCard_active__nz0kO","clickable":"SimpleOptionCard_clickable__Jluz9","icon":"SimpleOptionCard_icon__LIAsq"};